import { DialogComponent } from '@theme/dialog';

class IngredientsDrawer extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.section = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
    this.section?.addEventListener('click', this.openFromLink);
  }

  disconnectedCallback() {
    this.section?.removeEventListener('click', this.openFromLink);
    super.disconnectedCallback();
  }

  openFromLink = (event) => {
    const link = event.target.closest('a');
    if (!link || !link.closest('.product-details')) return;
    const href = link.getAttribute('href');
    const target = new URL(link.href, window.location.href);
    // Support the existing rich-text link saved in the theme editor as well.
    const legacyLink = href === '#' && link.textContent.trim().toLowerCase() === 'see full ingredient list';
    const ingredientsLink = target.hash === '#ingredients-list'
      && target.origin === window.location.origin
      && target.pathname === window.location.pathname;
    if (!ingredientsLink && !legacyLink) return;
    event.preventDefault();
    this.showDialog();
  };
}

if (!customElements.get('ingredients-drawer')) {
  customElements.define('ingredients-drawer', IngredientsDrawer);
}
